import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { getCompanyDetailsApi, getStatesData, updateCompanyApi } from '_services';
import { CommonInput, CropModal, CustomSelect } from 'components';
import Tab from 'components/common/Tab'
import ImageCropModal from 'components/ImageModify/ImageCropModal';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { companyImageUpload } from 'features';
import { errorSchema, utils } from 'helper';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Checkbox } from 'pages/User/AddUser';
import { Accordion } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { LuUpload } from "react-icons/lu";
import { useDispatch } from 'react-redux';
import StorageService from 'utils/StorageServices';
import { HiChevronDown } from "react-icons/hi2";
import CompanySetting from './CompanySetting';
import InvoiceFormat from './InvoiceFormat';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const CompanyProfile = () => {
    const dispatch = useDispatch();
    useDocumentTitle("Company | T360");

    const query = useQuery();
    const navigate = useNavigate();
    const location = useLocation();

    const tbn = query.get('tbn') || 1;

    const object = {
        company_id: StorageService.getCompanyId(),
        company: "",
        contact_no: "",
        alt_contact_no: "",
        email_id: "",
        website: "",
        entity_type: '',
        gst_no: "",
        gst_state:{},
        pan_no: "",
        fssai_licence: "",
        address_line1: "",
        address_line2: "",
        state: {},
        city: {},
        pincode: "",
        company_type: []
    }

    const {
        masterData,
        setMasterData,
        cities,
        setCities,
    } = useContext(UserContext);
    const [activeTab, setActiveTab] = useState(Number(tbn));
    const [companyDetails, setCompanyDetails] = useState('')
    const [form, setForm] = useState(object)
    const [formError, setFormError] = useState("");
    const [entityList, setEntityList] = useState([])
    const [filteredCities, setFilteredCities] = useState([]);
    const [stateValue, setStateValue] = useState("");
    const [cityDetails, setCityDetails] = useState({ label: "", value: "" });
    const [isLoading, setIsLoading] = useState(false)
    const companyRef = useRef(null)
    const [isEqal, setIsEqal] = useState(false)
    const [croppedImage, setCroppedImage] = useState(null);
    const [imageLoading, setImageLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [originalImage, setOriginalImage] = useState(
        null
    );

    useEffect(() => {
        if (cities) {
            const optionsCity = cities?.map((d) => {
                return {
                    ...d,
                    label: `${d?.name}, ${d?.stateCode}`,
                    value: `${d?.name}`,
                };
            });
            setFilteredCities(optionsCity);

        } else {
            setCities(JSON.parse(StorageService.getCities()));
        }

        if (masterData === null) {
            setMasterData(JSON.parse(StorageService.getLocalItem("master_data")));
        }

    }, [cities, masterData]);

    useEffect(() => {
        if (masterData) {

            setEntityList(masterData?.entity_type_list?.map((i) => {
                return {
                    label: i?.name,
                    value: i?.id
                }
            }))
        }
    }, [masterData])

    useEffect(() => {
        const isEqual = JSON.stringify(companyRef.current) === JSON.stringify(form);
        setIsEqal(isEqual);
    }, [form]);

    useEffect(() => {
        getComapnyDetailsHandle()
    }, [])

    useEffect(() => {
        if (form.logo && form.logo !== companyRef.current?.logo) {
            handleSubmit()
        }
    }, [form.logo])

    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.name,
            value: data?.name,
        });

        setCityDetails({
            label: data?.name,
            value: data?.name,
        });

        getStatesByApi(data?.countryCode, data?.stateCode);

    };




    const getComapnyDetailsHandle = async () => {
        try {
            const res = await getCompanyDetailsApi({ company_id: StorageService.getCompanyId() })
            setCompanyDetails(res?.data?.company)
            const d = res?.data?.company
            const details = {

                company: d?.company || "",
                contact_no: d?.contact_no || "",
                alt_contact_no: d?.alt_contact_no || "",
                email_id: d?.email_id || "",
                entity_type: d?.entity_type,
                website: d?.website || "",
                gst_no: d?.gst_no || '',
                gst_state: d?.gst_state || {},
                pan_no: d?.pan_no || "",
                fssai_licence: d?.fssai_licence || "",
                address_line1: d?.address_line1 || "",
                address_line2: d?.address_line2 || "",
                state: d?.state,
                city: d?.city,
                pincode: d?.pincode || "",
                company_type: d?.company_type?.map((i) => i?._id),
                logo: d?.logo || "",
            }

            setForm((pre) => {
                companyRef.current = { ...pre, ...details }
                return ({ ...pre, ...details })
            })
            setStateValue(d?.state)
            setCityDetails(d?.city)

        } catch (error) {

        }
    }

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode,
                stateCode: stateCode
            }
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                setStateValue({ ...response?.data[0], label: response?.data[0]?.name, value: response?.data[0]?.name });
                setForm((pre) => ({ ...pre, state: { label: response?.data[0]?.name, value: response?.data[0]?.name } }))
            }
        } catch (error) {

        }
    }

    const handleOnChange = async (name, value) => {
        const stateObj = { ...form, [name]: value };

        if(name === "gst_no" && value.length ===15){
             let gstCode = parseInt(value.slice(0, 2), 10);
                  stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
        }

        console.log("stateObj",stateObj);

        setForm(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                stateObj,
                errorSchema.updateCompanyModalSchema
            );

            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const callBackTab = (data) => {
        setActiveTab(data);
        const params = new URLSearchParams(location.search);
        params.set('tbn', data);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const profileProps = {
        tabList: constant?.companyProfile_settingTabs,
        callBackTab: callBackTab,
        activeTab: activeTab
    }

    const handleCheckboxChange = (e, item) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            // Add item if checked and not already present
            setForm((prevForm) => ({
                ...prevForm,
                company_type: [...prevForm.company_type, item._id,],
            }));
        } else {
            // Remove item if unchecked
            setForm((prevForm) => ({
                ...prevForm,
                company_type: prevForm.company_type.filter(
                    (type) => type !== item._id
                ),
            }));
        }
    };

    const handleSubmit = async () => {
        const payload = {
            ...form
        }
        const validationResult = await utils.checkFormError(
            form,
            errorSchema.updateCompanyModalSchema
        );

        setFormError(validationResult)

        if (validationResult == true) {
            setIsLoading(true)
            try {

                const res = await updateCompanyApi(payload)

                if (res?.responseCode == 200) {
                    setIsLoading(false)
                    getComapnyDetailsHandle()
                    toast.success(res?.responseMessage)
                    companyRef.current = { ...form }
                } else {
                    setIsLoading(false)
                    setCroppedImage(null);
                    toast.error(res?.responseMessage)
                }

            } catch (error) {
                setIsLoading(false)
            }
        }


    }

    async function createFile(path) {
        setImageLoading(true)
        let response = await fetch(path);
        let data = await response.blob()
        let metadata = {
            type: 'image/jpeg'
        };
        let file = new File([data], "test.jpg", metadata);
        const formData = new FormData()
        formData.append("logo", file)
        if (formData) {
            const res = await dispatch(companyImageUpload(formData));
            if (res?.payload?.responseCode === 200) {
                setForm({ ...form, logo: res?.payload?.data?.path })
                setImageLoading(false)
                setIsModalOpen(false);
            }
        }
        setIsModalOpen(false);

    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleCropComplete = async (croppedImageUrl) => {
        setCroppedImage(croppedImageUrl);
        await createFile(croppedImageUrl)
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === "string") {
                setOriginalImage(reader.result); 
                setIsModalOpen(true); 
            }
            e.target.value = null;
        };
        reader.readAsDataURL(file);
    };


    return (
        <div className='__profilCmp_main' >
            <div className='__setsHeads'>
                <h4>{companyDetails?.company}</h4>
                {companyDetails?.company_code && <span className='__idTag'>ID:{companyDetails?.company_code}</span>}
            </div>

            <div className='__setsContent_prt'>
                <Tab {...profileProps} invoiceBillRaiseClass="settingTbs" />

                {activeTab === 1 && (
                    <>
                        <div className='__stContent'>
                            <div className='__notVerify_bx'>
                                <p>Your company is not verified | Verify your company Detail to get more genuine loads, Bids & much more</p>
                                <button>Verify Now</button>
                            </div>

                            <div className='__cprPr_otr'>
                                <div className='__cprPr_inr'>
                                    <div>
                                        <p className='__cpl_txt'>Company Logo</p>
                                        <div className='__cpr_lg_bx' >
                                            <div>
                                                <input type="file" id='_cpLogo' style={{ display: 'none' }} onChange={handleFileChange} />
                                                <label htmlFor="_cpLogo" className='_cpLogo_upload'>

                                                    {croppedImage || form?.logo ? (
                                                        <img className="_cpLogo_upload" src={`${masterData?.s3_url}${form?.logo}` || croppedImage} alt="Cropped Preview" />
                                                    ) : (
                                                        <LuUpload className="" />
                                                    )}
                                                </label>
                                            </div>
                                            <p>Preferred Image Dimensions: 240 x 240 pixels @ 72 DPI Maximum File Size: 1MB</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Business Name"
                                                        placeholder="Business Name"

                                                        value={form?.company ? form?.company : ""}
                                                        name="company"
                                                        focus={!!formError?.company}
                                                        error={formError.company}
                                                        onChange={({ target: { name, value } }) =>
                                                            handleOnChange(name, value)
                                                        }
                                                        maxLength={40}
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CustomSelect
                                                        label="Entity Type"
                                                        options={entityList}
                                                        onSelect={(data) => {
                                                            handleOnChange("entity_type", data?.value)
                                                        }}
                                                        placeholder="Select Entity"
                                                        error={formError["entity_type"]}
                                                        value={entityList?.find((i) => i.value == form?.entity_type)}

                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Contact Number"
                                                        placeholder="Contact Number"
                                                        value={
                                                            form?.contact_no ? form?.contact_no : ""
                                                        }
                                                        maxLength={10}
                                                        disabled

                                                        name="contact_no"
                                                        focus={!!formError?.contact_no}
                                                        error={formError.contact_no}
                                                        onChange={({ target: { name, value } }) => {
                                                            if (/^\d*$/.test(value)) {
                                                                handleOnChange(name, value);
                                                                // setPhoneError("");
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Alternate Contact Number"
                                                        placeholder="Alternate Contact Number"

                                                        value={
                                                            form?.alt_contact_no ? form?.alt_contact_no : ""
                                                        }
                                                        maxLength={10}

                                                        name="alt_contact_no"
                                                        focus={!!formError?.alt_contact_no}
                                                        error={formError.alt_contact_no}
                                                        onChange={({ target: { name, value } }) => {
                                                            // Remove all non-digit characters (anything that's not 0-9)
                                                            let cleanedValue = value.replace(/\D/g, '');

                                                            // Remove '91' or '+91' from start if present and extra digits exist
                                                            if (cleanedValue.startsWith('91') && cleanedValue.length > 10) {
                                                                cleanedValue = cleanedValue.substring(2);
                                                            }

                                                            // Allow only if the result is 10 digits or fewer
                                                            if (/^\d{0,10}$/.test(cleanedValue)) {
                                                                handleOnChange(name, cleanedValue);
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Email ID"
                                                        placeholder="Email ID"
                                                        value={
                                                            form?.email_id ? form?.email_id : ""
                                                        }
                                                        name="email_id"
                                                        focus={!!formError?.email_id}
                                                        error={formError.email_id}
                                                        onChange={({ target: { name, value } }) => {

                                                            handleOnChange(name, value);

                                                        }}
                                                        maxLength={20}

                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Website"
                                                        placeholder="Website"

                                                        value={
                                                            form?.website ? form?.website : ""
                                                        }

                                                        name="website"
                                                        focus={!!formError?.website}
                                                        error={formError.website}
                                                        onChange={({ target: { name, value } }) => {

                                                            handleOnChange(name, value);
                                                            // setPhoneError("");

                                                        }}
                                                        maxLength={30}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>GST Registration</p>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="GST Number"
                                                        placeholder="GST Number"
                                                        value={form?.gst_no ? form?.gst_no : ""}
                                                        name="gst_no"
                                                        focus={!!formError?.gst_no}
                                                        error={formError.gst_no}
                                                        maxLength={15}
                                                        onChange={({ target: { name, value } }) => {
                                                            const cleanedValue = value.replace(/[^a-zA-Z0-9 ]+/g, "");

                                                            if (typeof handleOnChange === "function") {
                                                                // handleOnChange(name, cleanedValue);

                                                                const upperValue = cleanedValue.toUpperCase();
                                                                handleOnChange(name, upperValue)
                                                            }

                                                        }

                                                        }
                                                    />
                                                </div>
                                               {form?.gst_no && <div className='__cp_flex_half'>
                                                    <CustomSelect
                                                        options={filteredCities}
                                                        // onSelect={handleCityChange}
                                                        placeholder="Select a state"
                                                        value={form?.gst_state}
                                                        disabled={true}
                                                    />
                                                </div>}
                                            </div>

                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="PAN Number"
                                                        placeholder="PAN Number"
                                                        name='pan_no'
                                                        value={
                                                            form?.pan_no ? form?.pan_no : ""
                                                        }
                                                        maxLength={10}

                                                        focus={!!formError?.pan_no}
                                                        error={formError.pan_no}
                                                        onChange={({ target: { name, value } }) => {
                                                            const cleanedValue = value.replace(/[^a-zA-Z0-9 ]+/g, "");

                                                            if (typeof handleOnChange === "function") {
                                                                // handleOnChange(name, cleanedValue);

                                                                const upperValue = cleanedValue.toUpperCase();
                                                                handleOnChange(name, upperValue)
                                                            }
                                                        }

                                                        }
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Fssai License Number"
                                                        placeholder="Fssai License Number"
                                                        name='fssai_licence'
                                                        value={
                                                            form?.fssai_licence ? form?.fssai_licence : ""
                                                        }

                                                        maxLength={14}
                                                        focus={!!formError?.fssai_licence}
                                                        error={formError.fssai_licence}
                                                        onChange={({ target: { name, value } }) => {
                                                            const cleanedValue = value.replace(/[^a-zA-Z0-9 ]+/g, "");

                                                            if (typeof handleOnChange === "function") {
                                                                // handleOnChange(name, cleanedValue);

                                                                const upperValue = cleanedValue.toUpperCase();
                                                                handleOnChange(name, upperValue)
                                                            }
                                                        }

                                                        }

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>Business Address</p>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_full'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Address"
                                                        placeholder="Address"
                                                        name='address_line1'
                                                        value={
                                                            form?.address_line1 ? form?.address_line1 : ""
                                                        }


                                                        focus={!!formError?.address_line1}
                                                        error={formError.address_line1}
                                                        onChange={({ target: { name, value } }) => {

                                                            handleOnChange(name, value)
                                                        }

                                                        }
                                                        maxLength={100}
                                                    />
                                                </div>
                                            </div>

                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CustomSelect
                                                        options={filteredCities}
                                                        optionShowCityState={true}
                                                        onSelect={handleCityChange}
                                                        placeholder="Select a city"
                                                        error={formError["city.label"]}
                                                        value={cityDetails}
                                                        label="City"
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CustomSelect
                                                        options={filteredCities}
                                                        // onSelect={handleCityChange}
                                                        placeholder="Select a state"
                                                        value={stateValue}
                                                        disabled={true}
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="PIN Code"
                                                        placeholder="PIN Code"
                                                        value={form?.pincode ? form?.pincode : ""}
                                                        name="pincode"
                                                        maxLength={6}

                                                        focus={!!formError?.pincode}
                                                        error={formError.pincode}
                                                        onChange={({ target: { name, value } }) => {
                                                            if (/^\d*$/.test(value)) {
                                                                handleOnChange(name, value);
                                                                // setPhoneError("");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>Transport Type</p>

                                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>

                                            {masterData?.company_type?.map((item, index) => (
                                                <Checkbox
                                                    key={item._id}
                                                    name={item.name}
                                                    id={`company_type_${index}`}
                                                    className="__trkChecks"
                                                    // isDisabled={disableFields}
                                                    handleClick={(e) => handleCheckboxChange(e, item)}
                                                    isChecked={
                                                        form.company_type?.includes(item._id)
                                                    }
                                                    label={item.name}
                                                />
                                            ))}


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='__setFooter'>
                            <button className='__setBtn  __setBtn_update' disabled={isEqal || isLoading} onClick={() => handleSubmit()}>{!isLoading ? "Update" : "Proccesing.."}</button>
                            <button className='__setBtn  __setBtn_cancel' onClick={getComapnyDetailsHandle}>Cancel</button>
                        </div>
                    </>
                )}

                {activeTab === 2 && (
                    <CompanySetting setActiveTab={setActiveTab}/>
                )}
                {activeTab === 3 && (
                    <InvoiceFormat setActiveTab={setActiveTab}/>
                )}

                <ImageCropModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onCrop={handleCropComplete}
                    imageSrc={originalImage}
                    imageLoading={imageLoading}
                />

            </div>

        </div>
    )
}

export default CompanyProfile